import React from "react";
import I18n from "redux-i18n";
import { useSelector } from "react-redux";

import { getUserLanguage } from "redux/ws/selectors";
import { translations } from "lib/translations";

translations.options.suppress_warnings = true;

export default function I18nProvider({ children }) {
    const userLanguage = useSelector(getUserLanguage);
    return (
        <I18n translations={translations} initialLang={userLanguage || "en"}>
            {children}
        </I18n>
    );
}
